import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'blog-tile-header',
    templateUrl: './tile-header.component.html',
    styleUrls: ['./tile-header.component.scss'],
    imports: [CommonModule],
})
export class TileHeaderComponent {
    @Input() public text?: string;
    @Input() public imgSrc?: string;
}
